import axios from 'axios'
import store from '../store'
import router from '../router'

let handlingExpiry = false

function handleSessionExpired() {
  if (handlingExpiry) return
  handlingExpiry = true
  store.commit('DELETE_TOKEN')
  store.commit('DELETE_USER_DATA')
  localStorage.clear()
  delete axios.defaults.headers.common['Authorization']
  store.dispatch('toggleSnackbar', {
    text: 'Η συνεδρία έληξε',
    color: 'error'
  })
  router
    .push('/login')
    .catch(() => {})
    .finally(() => {
      handlingExpiry = false
    })
}

export default function init() {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
  axios.interceptors.response.use(
    (response) => {
      if (!response.config.url?.endsWith('/authentication/refresh')) {
        window.__lastActivity = Date.now()
      }
      return response
    },
    async (err) => {
      if (err.response && err.response.status === 401) {
        handleSessionExpired()
      }
      throw err
    }
  )
}
